import axiosConnect from "../../../utils/axiosConnect";
/**
 * Updates the scan assist count for a POCUS patient.
 * Calls POST /pocus/patients/{patientUid}/update-scan-assist-count/ with body { count }.
 */
var updateScanAssistCount = function updateScanAssistCount(patientUid, count) {
  var url = "/pocus/patients/".concat(patientUid, "/update-scan-assist-count/");
  return axiosConnect.post(url, {
    count: count
  }).then(function (_ref) {
    var data = _ref.data;
    return data;
  })["catch"](function (err) {
    console.error(err);
    throw err;
  });
};
export default updateScanAssistCount;